import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
    },
    panel: {
      position: 'absolute',
      top: theme.spacing(7),
      left: 0,
      right: 0,
      zIndex: 100,
      background: theme.palette.background.paper,
      borderRadius: 4,
      boxShadow: '0px 2px 16px rgba(152, 169, 188, 0.2)',
    },
    category: {
      [theme.breakpoints.up('sm')]: {
        '&:not(:last-child)': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    },
    categoryHeader: {
      padding: theme.spacing(2, 2, 1),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 4, 1),
      },
    },
    item: {
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2),
      '&:hover': {
        background: theme.palette.background.default,
        cursor: 'pointer',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        margin: theme.spacing(0, 2),
        padding: theme.spacing(1.5, 2),
        '&:not(:last-child)': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    },
    itemName: {
      marginRight: 'auto',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    name: {
      paddingRight: theme.spacing(3),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: theme.palette.text.primary,
    },
    itemInfo: {
      display: 'flex',
    },
    itemType: {
      paddingRight: theme.spacing(2),
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    itemNumber: {
      color: theme.palette.text.primary,
    },
    highlighted: {
      fontWeight: 700,
    },
    input: {
      height: theme.spacing(6),
      border: `1px solid ${theme.palette.grey[200]}`,
      background: `${theme.palette.background.paper} !important`,
      caretColor: theme.palette.primary.main,
      '&:hover': {
        border: `1px solid ${theme.palette.grey[300]} !important`,
      },
      '& input': {
        color: theme.palette.text.primary,
        fontWeight: 400,
        '&::placeholder': {
          fontFamily: theme.typography.fontFamily,
          letterSpacing: 0.5,
          fontSize: 16,
        },
      },
    },
    noResultWrapper: {
      padding: theme.spacing(5, 6.5),
      margin: '0 auto',
    },
    noResultTitle: {
      marginBottom: theme.spacing(2),
      color: theme.palette.grey[600],
      textAlign: 'center',
    },
    advices: {
      paddingInlineStart: '1rem',
      marginBlock: 0,
    },
    adviceItem: {
      '&::marker': {
        color: theme.palette.grey[400],
      },
    },
    advice: {
      color: theme.palette.grey[400],
    },
    viewAll: {
      textDecoration: 'none',
    },
    loadingWrapper: {
      padding: theme.spacing(5, 6.5),
      margin: '0 auto',
    },
    loadingTitle: {
      marginBottom: theme.spacing(2),
      color: theme.palette.grey[600],
      textAlign: 'center',
    },
    loadingText: {
      textAlign: 'center',
    },
  })
);
